// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3xqfJ","emails":"CreateEditClinics_emails__NLwts","emailTagLabel":"CreateEditClinics_emailTagLabel__15zR_"};